// extracted by mini-css-extract-plugin
export default {"title":"add-location_title__LsEz6","field":"add-location_field__PJtqP","line":"add-location_line__1ekow","content":"add-location_content__jOfSs"};